import React from 'react';
import HelpPageShell from '../../components/help/HelpPageShell';
import { propertyManagerHelpContent } from '../../content/help/propertyManagerHelpContent';

interface PropertyManagerHelpPageProps {
  onNavigate: (screen: string) => void;
}

export default function PropertyManagerHelpPage({ onNavigate }: PropertyManagerHelpPageProps) {
  const origin = React.useMemo(() => {
    try { return sessionStorage.getItem('cb.help.origin') || 'pm-dashboard'; } catch { return 'pm-dashboard'; }
  }, []);

  const backLabel = origin === 'pm-dashboard' ? '← Back to Dashboard' : '← Back';

  const handleBack = () => {
    try { sessionStorage.removeItem('cb.help.origin'); } catch {}
    onNavigate(origin);
  };

  return (
    <div>
      <div style={{ background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '10px 24px' }}>
        <button
          onClick={handleBack}
          style={{
            background: 'none',
            border: '1px solid #cbd5e1',
            borderRadius: 8,
            padding: '7px 14px',
            fontSize: 14,
            fontWeight: 600,
            color: '#334155',
            cursor: 'pointer',
          }}
        >
          {backLabel}
        </button>
      </div>
      <HelpPageShell
        role="property_manager"
        title="Property Manager Help Center"
        subtitle="Step-by-step guides for managing your portfolio, creating projects, reviewing bids, and handling payments."
        sections={propertyManagerHelpContent}
        pendingSectionStorageKey="cb.pm.help.section"
      />
    </div>
  );
}
